<template>
    <el-row class="footer_layout m-t-150 p-b-100" type="flex" justify="center" :span="24">
      <!-- col-1 -->
      <el-col :xs="12" :sm="14" :md="5" :lg="5" :xl="5" :offset="offsetResponsive()">
        <div class="grid-content bg-purple">
          <el-image style="width: 40%" :src="whichWebFunction()" fit="cover"></el-image>
          <!-- <el-image style="width: 40%" :src="logo" fit="cover"></el-image> -->
          <br/>
          <!-- <div class="footer_slogan m-l-5">Таныг төлөөлж үйлдвэртэй <br/>холбогдох болно.</div> -->
        </div>
      </el-col>
      <!-- col-2 -->
      <el-col :md="5" :lg="5" :xl="5" class="desktop_menu">
        <div>
          <span class="menu_text">Компани</span><br/>
          <span class="footer_slogan">Бидний тухай</span>
        </div>
      </el-col>
      <!-- col-3 -->
      <el-col :md="5" :lg="5" :xl="5" class="desktop_menu">
        <div>
          <router-link class="cursor menu_text" to="/">
            <span class="menu_text">Цэс</span><br/>
          </router-link>
          <router-link class="cursor menu_text" to="/">
            <span class="footer_slogan">{{ $t('home') }}</span><br/>
          </router-link>
          <router-link class="cursor menu_text" to="/products">
            <span class="footer_slogan">{{ $t('product') }}</span><br/>
          </router-link>
          <!-- <router-link class="cursor menu_text" to="/contact">
            <span class="footer_slogan">{{ $t('contact') }}</span><br/>
          </router-link>
          <router-link class="cursor menu_text" to="/">
            <span class="footer_slogan">COMPANY</span><br/>
          </router-link> -->
        </div>
      </el-col>
      <!-- col-4 -->
      <el-col :xs="10" :sm="5" :md="5" :lg="5" :xl="5">
        <div class="rigth">
          <span class="menu_text">Холбоо барих</span><br/>
          <span class="footer_slogan"><i class="el-icon-phone"></i>9337-2222</span><br/>
          <!-- <span class="footer_slogan">FB: <a href="https://www.facebook.com/borjigoncargo" class="social_color">Iteever </a></span><br/>
          <span class="footer_slogan">IG: <a href="https://www.instagram.com/iteever.mn" class="social_color">iteever.mn </a></span><br/> -->
        </div>
      </el-col>
    </el-row>
  </template>
<script>
// import IteeverLogo from '@/assets/iteever_logo_hondlon.png'
import EruulhunLogo from '@/assets/eruulhun_logo.jpg'
import IteeverLogo from '@/assets/iteever_logo_hondlon.png'
export default {
  name: 'FooterPage',
  data: function () {
    return {
      iteever_logo: IteeverLogo,
      eruulhun_logo: EruulhunLogo
    }
  },
  methods: {
    offsetResponsive () {
      if (this.windowWidth > 700) {
        return 2
      } else {
        return 2
      }
    },
    type_position () {
      if (this.windowWidth > 900) {
        return 'flex'
      } else {
        return 'none'
      }
    },
    whichWebFunction () {
      if (window.location.hostname === 'www.iteever.mn') {
        return this.iteever_logo
      } else if (window.location.hostname === 'www.eruulhun.com') {
        return this.eruulhun_logo
      } else if (window.location.hostname === 'localhost') {
        return this.eruulhun_logo
      }
    }
  }
}

</script>

<style>
  .social_color{
    color: #5E1EE5;
  }
  .rigth{
    margin-right: 10px;
  }
  @media all and (max-width: 991px) {
    .desktop_menu {
      display: none;
    }
  }
</style>
